export class User {
    tid: number;
    name: string;
    given_name: string;
    family_name: string;
    unique_name: string;
    ipaddr: string;
    token?: string;

    public constructor(init?: Partial<User>) {
        Object.assign(this, init);
    }
}
